import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/site/LegalPage";
import { legalPages } from "@/content/legal";
import { SITE_URL } from "@/lib/seo";

const d = "The terms that apply when you use the Leadership Edge Live website and services.";

export const Route = createFileRoute("/terms-and-conditions")({
  head: () => ({
    links: [{ rel: "canonical", href: `${SITE_URL}/terms-and-conditions/` }],
    meta: [
      { title: "Terms and Conditions | Leadership Edge Live" },
      { name: "description", content: d },
      { property: "og:title", content: "Terms and Conditions | Leadership Edge Live" },
      { property: "og:description", content: d },
      { property: "og:type", content: "article" },
    ],
  }),
  component: () => (
    <LegalPage title="Terms and Conditions" blocks={legalPages["terms-and-conditions"]} />
  ),
});
